<template>
  <tr class="subheader" v-bind="$attrs">
    <td
      class="has-background-white-ter"
      :colspan="colspan">
      <div class="level my-0">

        <div class="level-left">
          <div class="has-text-weight-bold mr-2">
            {{ project.project_name }}:
          </div>
          <div>
            {{ project.address }}
          </div>
        </div>

        <div class="level-right">
          <div class="mr-3">
            <span class="is-size-7">Sales Person:</span>
            {{ project.crm_object.Owner.name }}
          </div>
          <div class="mr-3">
            <span class="is-size-7">Stage:</span>
            {{ project.crm_object.Stage }}
          </div>
          <button
            title="add new proposal"
            class="button is-primary is-small"
            @click="$emit('add-proposal', project.id)">
            <span class="icon is-small">
              <i class="fas fa-plus"></i>
            </span>
          </button>
        </div>

      </div>
    </td>
  </tr>
</template>

<script>
export default {
  props: {
    colspan: {
      type: Number,
      default: 6
    },
    project: {
      type: Object,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/table.scss';
</style>
